module.exports = __webpack_public_path__ + "static/img/policy-footer_600.5e3e14c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/policy-footer_600.png
// module id = n6k+
// module chunks = 0